// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 添加 ?????升级为v2

「已废弃」升级为v2 POST /official_document/archive/add */
export async function postOfficialDocumentArchiveAdd(
  body: API.OfficialDocumentArchiveRequest,
  options?: { [key: string]: any },
) {
  return request<API.OfficialDocumentArchive>('/official_document/archive/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 导出 ?????升级为v2

「已废弃」升级为v2 POST /official_document/archive/export */
export async function postOfficialDocumentArchiveOpenApiExport(
  body: API.LongIdsRequest,
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>('/official_document/archive/export', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取可导出列 ?????升级为v2

「已废弃」升级为v2 GET /official_document/archive/export/columns */
export async function getOfficialDocumentArchiveOpenApiExportColumns(options?: {
  [key: string]: any;
}) {
  return request<API.Vo[]>('/official_document/archive/export/columns', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 列表 ?????升级为v2

「已废弃」升级为v2 GET /official_document/archive/list */
export async function getOfficialDocumentArchiveList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getOfficialDocumentArchiveListParams,
  options?: { [key: string]: any },
) {
  return request<API.SPageC2ABOfficialDocumentArchiveVoC2BB>('/official_document/archive/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
